import { SubscriptionActionType } from './actions';
import { SubscriptionActionListEnum } from './actionsTypes';

interface SubscriptionPlan {
  id: string;
  name: string;
  price: number;
  durationDays: number;
  features: string[];
  active: boolean;
  createdAt: string;
}

interface UserSubscription {
  id: string;
  userId: string;
  planId: string;
  startDate: string;
  endDate: string;
  status: 'active' | 'expired' | 'cancelled';
  paymentId?: string;
  createdAt: string;
  plan?: SubscriptionPlan;
}

export interface SubscriptionState {
  currentSubscription: UserSubscription | null;
  hasSubscription: boolean;
  tokensRemaining: number;
  isLoading: boolean;
  error: string | null;
  isInitialized: boolean;
}

const subscriptionInitialState: SubscriptionState = {
  currentSubscription: null,
  hasSubscription: false,
  tokensRemaining: 0,
  isLoading: false,
  error: null,
  isInitialized: false,
};

const subscription = (state: SubscriptionState = subscriptionInitialState, action: SubscriptionActionType): SubscriptionState => {
  switch (action.type) {
    case SubscriptionActionListEnum.SET_CURRENT_SUBSCRIPTION:
      return {
        ...state,
        currentSubscription: action.subscription,
        hasSubscription: action.hasSubscription,
        tokensRemaining: action.tokensRemaining,
        isLoading: false,
        error: null,
        isInitialized: true,
      };

    case SubscriptionActionListEnum.SET_SUBSCRIPTION_LOADING:
      return {
        ...state,
        isLoading: action.isLoading,
        error: null,
      };

    case SubscriptionActionListEnum.SET_SUBSCRIPTION_ERROR:
      return {
        ...state,
        error: action.error,
        isLoading: false,
      };

    case SubscriptionActionListEnum.CLEAR_SUBSCRIPTION:
      return {
        ...subscriptionInitialState,
        isInitialized: true,
      };

    case SubscriptionActionListEnum.SET_TOKENS_REMAINING:
      return {
        ...state,
        tokensRemaining: action.tokensRemaining,
      };

    default:
      return state;
  }
};

export default subscription;